import { styled } from '@mui/material/styles'

export const StyledTextLabel = styled('div')({
  marginRight: 2,
  fontWeight: 500,
  color: '#373d57',
  display: 'inline-grid',
  justifyItems: 'center',
})
